<template>
	<div>
		<TriangleImage
			:title="title"
			:subtitle="subtitle"
		/>

		<div class="container">
			<div class="content">
				<section class="form center">
					<h2 v-if="template === 'meal-kit'">Ricevi il tuo regalo per il primo ordine su quomi.it</h2>
					<p v-if="template === 'meal-kit'">Inserisci i dati nei campi sottostanti per ricevere sulla tua email un codice speciale da utilizzare sul tuo primo box.</p>

					<h2 v-if="template === 'box-quomi'">Vuoi provare una nuova esperienza in cucina?</h2>
					<p v-if="template === 'box-quomi'">Lascia la tua mail per ricevere l'offerta del tuo <b>primo box</b> a partire da soli <s>39 €</s> <b>19,90 €</b></p>

					<br>

					<p v-if="user">Email: {{ email }}</p>

					<div class="flex flex-center">
						<input type="email" v-if="!user" class="form-control" v-model="email" placeholder="La tua mail" autocomplete="email">
						<span v-if="template === 'meal-kit'">&nbsp;</span>
						<input type="text" name="code" class="form-control" v-model="codeMealKit" placeholder="Prova d’acquisto" v-if="template === 'meal-kit'">
					</div>

					<div>
						<label class="">
							<input type="checkbox" v-model="checked"> Accetto la <router-link :to="{ name: 'privacy-policy' }" class="link-detail" title="Privacy policy">privacy policy</router-link> di Quomi
						</label>
					</div>

					
						<CTA
							:content="`Ricevi buono di prova`"
							@click="send()"
							:disabled="!checked || newsletterLoading"
						/>
					

					<div
						v-if="newsletterFlash"
						class="flash"
						:class="newsletterState"
						v-html="newsletterFlash"
					/>

				</section>

				<section>
					<Usp :template="'plans'">
						<h2 slot="titles">Che cos’è Quomi?</h2>
					</Usp>
				</section>

				<section class="paragraph center">
					<p><b>Prova la tua prima Food Box senza impegno!</b><br>
					Potrai sospendere l'abbonamento dopo il primo ordine</p>
				</section>

				<br>

				<section class="paragraph">
					<h2 v-if="template === 'meal-kit'">La rivoluzione dei meal kit</h2>
					<p v-if="template === 'meal-kit'">Il <b>Box Cucina Facile</b> è la soluzione perfetta per chi ricerca qualità, convenienza e un’alimentazione sana in cucina. Scegliere un <b>meal kit</b> di questo tipo, aiuta non solo a variare le abitudini alimentari e a divertirsi nel provare nuovi sapori, ma anche a gestire al meglio le quantità di cibo grazie agli ingredienti dosati e alle <b>ricette spiegate passo per passo</b>. Quomi è stata la prima realtà ad introdurre in Italia il modello dei meal kit, offrendo un servizio su abbonamento iper flessibile e senza vincoli.</p>
					<h2>Ogni settimana, cibo sano e di qualità</h2>
					<p>L'alimentazione è uno dei fattori determinanti per la nostra salute, per questo Quomi sostiene <b><nobr>i principi</nobr> della dieta mediterranea</b> in quanto sinonimo di equilibrio, gusto ma anche convivialità sulle nostre tavole. Una selezione accurata dei fornitori e il rispetto della <b>stagionalità dei prodotti</b> offerti all’interno dei nostri meal kit, permette di garantire sempre freschezza e qualità assoluta da condividere a tavola con famigliari e amici.</p>

					<h2>Prova il sapore unico delle ricette Quomi</h2>
					<p>Scopri le ricette pensate per te da Quomi. Ogni settimana potrai trovare una novità da introdurre nella tua cucina.</p>
				</section>

				<section id="slider">
					<h2>Ricette della settimana</h2>
					<Slick>
						<div slot="slides" class='recipe' v-for="(item, index) in menu" :key="index">
							<img :src="item.images.big" :alt='item.title'>
							<div class="recipe-name">{{ item.title }}</div>
						</div>
					</Slick>
				</section>

				<div class="center">
					<router-link :to="{ name: 'plans' }" title="Ricette">
						<CTA
							:content="user ? 'Vai alle ricette' : 'Scegli il tuo piano'"
							isArrow	
						/>
					</router-link>
				</div>

			</div>
		</div>
	</div>
</template>

<script type = "text/javascript" >

import { goSlick } from '../assets/js/slick.js'
import { MailApi } from '../api/MailApi'

import { WeekPlanApi } from '../api/WeekPlanApi'
import TriangleImage from '@/components/TriangleImage'
import Usp from '@/components/Usp'
import { newsletter } from '../mixins/newsletter'

import Slick from '@/components/Slick'

export default {

	data () {
		return {
			menu: null,
			email: '',
			codeMealKit: '',
			checked: false,
		}
	},

	mixins: [
		newsletter
	],

	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		},
		template: {
			type: String,
			default: null
		}
	},

	components: {
		TriangleImage,
		Slick,
		Usp
	},

	methods: {
		send () {
			this.newsletterLoading = true
			this.newsletterFlash = ''

			var compaign
			if (this.template === 'box-quomi') compaign = 'awin'
			if (this.template === 'meal-kit') compaign = 'meal-kit'

			if (this.codeIsOk) {
				this.$_newsletter_newsletterSubscribe({ utm_campaign: compaign, email: this.email })
			} else {
				this.newsletterFlash = "Codice prova d'aqcuisto non valido"
				this.newsletterState = 'error'

				this.newsletterLoading = false
			}
		}
	},
	computed: {
		title () {
			if (this.template === 'box-quomi') return 'La box per le tue cene a casa, senza pensieri'
			if (this.template === 'meal-kit') return 'Ti è piaciuto il meal Kit<br>Cucina Facile di Quomi?'
		},
		subtitle () {
			if (this.template === 'box-quomi') return 'Scopri il nuovo servizio che consegna ogni settimana un box ricco di ingredienti e ricette, comodamente a casa tua'
			if (this.template === 'meal-kit') return 'Scopri il nuovo servizio che consegna ogni settimana un box ricco di ingredienti e ricette, comodamente a casa tua'
		},

		codeIsOk () {
			if (this.template === 'box-quomi') return true
			return this.codeMealKit.toUpperCase() === 'QUC88'
		}
	},
	mounted () {
		this.email = this.user ? this.user.email : null

		var wm = new WeekPlanApi()
		wm.current({}).then(response => {
			this.menu = response.body.data.resource.recipes
		}).then(response => {
			goSlick()
		})
	}
}

</script>

<style scoped>

.triangle-image {
	background-image: url("../assets/img/covers/mealkit.jpg");
	min-height: 600px;
}

section + section {
	margin-top: 50px;
}

.paragraph {
	max-width: 800px;
	margin: 0 auto;
}

.paragraph p + h2 {
	margin-top: 30px;
}
.form {
	max-width: 800px;
	margin: 0 auto
}

.form input {
	max-width: 300px;
}

.flash {
	margin: 10px auto 0 auto;
}

.error {
	color: tomato;
}

.success {
	color: green;
}

</style>
